import React from 'react';
import { FaRegQuestionCircle } from 'react-icons/fa';
import { IoStatsChartSharp } from 'react-icons/io5';
import {
  Box, Flex, Icon,
  Text, Tooltip
} from '@chakra-ui/react';
import millify from 'millify';
import PropTypes from 'prop-types';
import {inAppText} from "../../../../constants/inAppText";

function PresetReportButton({
  isLast = false,
  title = 'Sample Report',
  color = 'greyScale.900',
  num = '0',
  onClick = () => {},
  selected = false,
  info = inAppText.tooltips.comingSoon,
  ...props
}) {
  return (
    <Box
      _focus={{ outline: 'none' }}
      _hover={{
        cursor: 'pointer',
        boxShadow: '-webkit-box-shadow: 0px 8px 28px rgba(0, 0, 0, 0.25); box-shadow: 0px 8px 28px rgba(0, 0, 0, 0.25)'
      }}
      bg="white"
      border="2px solid"
      borderColor={selected ? color : 'transparent'}
      borderRadius="xs"
      boxShadow="base3"
      display="flex"
      flex={1}
      flexDirection="column"
      justifyContent="space-between"
      marginRight={!isLast && 8}
      minH={20}
      minW={230}
      position="relative"
      px={8}
      py={4}
      textTransform="uppercase"
      onClick={onClick}
      {...props}
    >
      <Tooltip
        label={info}
        placement="top"
        portalProps={{ appendToParentPortal: true }}
      >
        <Icon
          color={color}
          icon={<Icon as={FaRegQuestionCircle} />}
          minWidth={0}
          position="absolute"
          right={2}
          size="sm"
          top={2}
          variant="ghost"
        />
      </Tooltip>
      <Text mb={7} textAlign="left" textStyle="bodyLg600">{title}</Text>
      <Flex
        alignItems="baseline"
        color={color}
        justify="space-between"
        textStyle="displaySm"
      >
        <Icon as={IoStatsChartSharp} />
        <Text fontWeight="semibold">{millify(num, { precision: 1 })}</Text>
      </Flex>
    </Box>
  );
}
PresetReportButton.propTypes = {
  isLast: PropTypes.bool,
  title: PropTypes.string,
  color: PropTypes.string,
  num: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onClick: PropTypes.func
};

export default PresetReportButton;
